const workHistory = [
  {
    company: "AREA",
    location: "New York, NY",
    role: "Full-Time Design Intern",
    year: "Jun 2026 — Sep 2026",
    details: [
      "Supported the design team across day-to-day development and production processes.",
      "Gained hands-on experience across the professional design and development process, from concept development to execution.",
    ],
  },
  {
    company: "Tory Burch",
    location: "New York, NY",
    role: "Collaborative Design Project",
    year: "Jan 2026 — May 2026",
    details: [
      "Developed experimental textile and silhouette concepts inspired by American classic wear and youth culture.",
      "Selected and featured in Harper's Bazaar for work developed through the collaboration.",
    ],
  },
  {
    company: "Fashion Void",
    location: "New York, NY",
    role: "Founder & Developer",
    year: "Dec 2025 — Present",
    details: [
      "Founded Fashion Void, an AI-powered runway search and research platform designed for runway research, trend analysis, and brand comparison.",
      "Developed and launched the platform using Next.js and Supabase, integrating fashion research with data-driven tools.",
    ],
  },
  {
    company: "Scratchy Sketch",
    location: "Seoul, South Korea",
    role: "Founder & Designer",
    year: "Mar 2021 — Jun 2021",
    details: [
      "Founded an independent fashion brand as a platform for developing and expressing a personal design identity.",
      "Successfully launched and funded collections through consumer-backed crowdfunding campaigns.",
    ],
  },
  {
    company: "Dr. Martens Korea",
    location: "Seoul, South Korea",
    role: "Marketing Associate",
    year: "Jun 2020 — Dec 2020",
    details: [
      "Participated in digital marketing and promotional projects across social media platforms.",
      "Recognized with the Best Supporter Award for contributions to brand promotional activities.",
    ],
  },
  {
    company: "Ephe",
    location: "Seoul, South Korea",
    role: "Design Intern",
    year: "Jun 2019 — Dec 2019",
    details: [],
  },
];

const education = [
  {
    year: "Sep 2025 — Present",
    degree: "MFA · Fashion Design and Society",
    place: "Parsons School of Design, New York",
  },
  {
    year: "Sep 2023 — Apr 2024",
    degree: "Graduate Diploma · Fashion and Textile",
    place: "Royal College of Art, London",
  },
  {
    year: "Mar 2018 — Aug 2023",
    degree: "BSc · Fashion and Textile",
    place: "Seoul National University",
  },
];

function WorkEntry({ item }) {
  return (
    <li className="reveal grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 py-10 md:py-14 border-b border-black/10 last:border-b-0">
      {/* Left — company / role / date */}
      <div className="lg:col-span-5">
        <h3 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-tight">
          {item.company}
        </h3>
        <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.22em] text-black/70">
          {item.role}
        </p>
        <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.22em] text-black/40">
          {item.year} · {item.location}
        </p>
      </div>

      {/* Right — details */}
      <div className="lg:col-span-7 lg:pl-6 lg:border-l lg:border-black/10">
        {item.details.length > 0 ? (
          <ul className="space-y-4">
            {item.details.map((d, i) => (
              <li
                key={i}
                className="text-base md:text-lg text-black/75 leading-relaxed"
              >
                <span className="text-neon-pink mr-3">·</span>
                {d}
              </li>
            ))}
          </ul>
        ) : (
          <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-black/30 italic">
            Details available upon request
          </p>
        )}
      </div>
    </li>
  );
}

function EducationEntry({ item }) {
  return (
    <li className="reveal grid grid-cols-12 gap-4 md:gap-6 py-6 md:py-8 border-b border-black/10 last:border-b-0">
      <span className="col-span-12 md:col-span-4 font-mono text-[10px] md:text-xs uppercase tracking-[0.22em] text-black/45 pt-1">
        {item.year}
      </span>
      <div className="col-span-12 md:col-span-8">
        <p className="font-display text-xl md:text-2xl leading-[1.15] tracking-tight">
          {item.degree}
        </p>
        <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.22em] text-black/50">
          {item.place}
        </p>
      </div>
    </li>
  );
}

export default function Resume() {
  return (
    <section
      id="resume"
      data-testid="resume-section"
      className="relative px-6 md:px-10 lg:px-16 py-28 md:py-36 border-t border-black/10"
    >
      <div className="flex items-center justify-between font-mono text-[10px] uppercase tracking-[0.22em] text-black/60">
        <span>(02.5) — Résumé</span>
        <span className="hidden md:inline">Work · Study</span>
      </div>

      {/* Work History — full width, one entry per row */}
      <div className="mt-14 md:mt-20">
        <h2
          data-testid="work-history-heading"
          className="font-display text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight"
        >
          Work <span className="italic text-neon-pink">history</span>.
        </h2>
        <ul className="mt-12 md:mt-16 border-t border-black/10">
          {workHistory.map((w, i) => (
            <WorkEntry key={i} item={w} />
          ))}
        </ul>
      </div>

      {/* Education — full width below */}
      <div className="mt-24 md:mt-32">
        <h2
          data-testid="education-heading"
          className="font-display text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight"
        >
          <span className="italic text-neon-lime">Education</span>.
        </h2>
        <ul className="mt-12 md:mt-16 max-w-4xl border-t border-black/10">
          {education.map((e, i) => (
            <EducationEntry key={i} item={e} />
          ))}
        </ul>
      </div>
    </section>
  );
}
